import { DataSecurityApplication } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetDataSecurityApplicationsRequest = KeyPaginationQueryParams & DynamicQueryParams;

export type GetDataSecurityApplicationsResponse = PaginatedResource<DataSecurityApplication>;

export const getDataSecurityApplications = createGetEndpoint<
	GetDataSecurityApplicationsRequest | undefined,
	GetDataSecurityApplicationsResponse
>((request) => `/api/v3/data-security/applications?${getQueryString(request)}`);
